import React from "react";
import {DateTime} from "luxon";
import flagIcon from "app/components/PublicProfiles/assets/flag.svg";
import { generateCurrencySymbol } from "app/routes/BuildProgram/Pricing/utils";
import Button from "app/components/Button/ButtonVariant";
import { useTranslation } from "react-i18next";
import styles from "./ProgramCard.module.scss";

const ProgramCard = ({ event, facility, getCoachAvatar, onClickRegister, alreadyRegistered = false, program = null }: any) => {
  const { t } = useTranslation();

  const getStatusButton = () => {
    if (!alreadyRegistered) {
      return <Button buttonType="secondary-filled" buttonStyles={styles["pub-register-btn"]} title={t('Register')} onClickFunc={() => onClickRegister(event)} />;
    }

    const statusCode = program?.registrationStatusCode;
    const statusText = program?.registrationStatus === "Pending Payment" ? t('Registered') : program?.registrationStatus;

    if (statusCode === "waitlisted") {
      return <Button buttonType="secondary-filled" buttonStyles={styles["pub-waitlisted-btn"]} title={statusText || t('Waitlisted')} onClickFunc={() => onClickRegister(event)} />;
    }

    return <Button buttonType="secondary-filled" buttonStyles={styles["pub-registered-btn"]} title={statusText || t('Registered')} onClickFunc={() => onClickRegister(event)} />;
  };

  return (
    <div key={event.id} className={styles["pub-facility-event-card"]}>
      <div className={styles["pub-facility-event-image-wrapper"]}>
        <img src={event.image} alt={event.title} className={styles["pub-facility-event-image"]} />
      </div>
      <div className={styles["pub-facility-event-info"]}>
        <h3 className={styles["pub-facility-event-title"]}>{event.title}</h3>
        <p className={styles["pub-facility-event-date"]}>{DateTime.fromISO(event.date).toFormat("EEEE, LLLL d, yyyy")}</p>
        <div className={styles["pub-facility-event-meta"]}>
          <div className={styles["pub-facility-event-facility"]}>
            <img src={flagIcon} alt="Facility" className={styles["pub-facility-event-icon"]} />
            <span>{facility?.name}</span>
          </div>
          <div className={styles["pub-facility-event-coach"]}>
            <img
              src={getCoachAvatar(event.coachAvatar)}
              alt={event.coachName || 'Coach'}
              className={styles["pub-facility-event-coach-avatar"]}
            />
            <span>{event.coachName}</span>
          </div>
        </div>
        <p className={styles["pub-facility-event-description"]}>{event.description}</p>
      </div>
      <div>
        <hr className={styles["pub-facility-divider"]} />
        <div className={styles["pub-facility-event-footer"]}>
          <span className={styles["pub-facility-event-price"]}>{event.isFree ? t('Free') : `${generateCurrencySymbol(event.priceCurrency)} ${event.price}`}</span>
          {getStatusButton()}
        </div>
      </div>
    </div>
  );
};

export default ProgramCard;
